// src/pages/Campaigns/Campaigns.js
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Paper,
  Divider,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  Box,
  Avatar,
  useTheme,
} from "@mui/material";
import {
  Google,
  MailOutline,
  Sms,
  Group,
  Event,
  People,
  Poll as SurveyIcon,
} from "@mui/icons-material";

export default function Campaigns() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { chatbotId: paramsChatbotId } = useParams();
  
  useEffect(() => {
    document.title = "Campaigns | KlonIT Web Application";
  }, []);

  const cards = [
    {
      title: "Gmail Auto-Responder",
      description:
        "Connect your Gmail to automatically read and process incoming emails. Leverage AI to generate contextual replies.",
      icon: <Google sx={{ fontSize: 60, color: "#DB4437" }} />,
      link: `/chatbot/${paramsChatbotId}/campaigns/Gmail`,
    },
    {
      title: "Outlook Auto-Responder",
      description:
        "Connect your Outlook to automatically read and process incoming emails. Leverage AI to generate contextual replies.",
      icon: <MailOutline sx={{ fontSize: 60, color: "#0078D4" }} />,
      link: `/chatbot/${paramsChatbotId}/campaigns/Outlook`,
    },
    {
      title: "SMS Campaign",
      description:
        "Send automated SMS campaigns with AI-driven message generation and response handling.",
      icon: <Sms sx={{ fontSize: 60, color: theme.palette.primary.main }} />,
      link: `/chatbot/${paramsChatbotId}/campaigns/Sms`,
    },
    {
      title: "Lead Management",
      description:
        "Connect your Salesforce or other CRM to manage and track customer leads efficiently.",
      icon: <Group sx={{ fontSize: 60, color: theme.palette.success.main }} />,
      link: `/chatbot/${paramsChatbotId}/campaigns/Lead`,
    },
    {
      title: "Volunteer Management",
      description:
        "Manage volunteers, track their availability, skills, and coordinate volunteer assignments.",
      icon: <People sx={{ fontSize: 60, color: "#4ECDC4" }} />,
      link: `/chatbot/${paramsChatbotId}/campaigns/volunteers`,
    },
    {
      title: "Event Management",
      description:
        "Create and manage events, track attendance, send invitations, and handle event logistics.",
      icon: <Event sx={{ fontSize: 60, color: "#FF6B6B" }} />,
      link: `/chatbot/${paramsChatbotId}/campaigns/events`,
    },
    // NEW: Add SurveyGenie card
    {
      title: "SurveyGenie",
      description:
        "Create and manage surveys with advanced question types, distribution options, and comprehensive analytics.",
      icon: <SurveyIcon sx={{ fontSize: 60, color: "#9C27B0" }} />,
      link: `/chatbot/${paramsChatbotId}/surveys`,
    },
  ];

  return (
      <Paper
               sx={{
                 p: 3,
                 mt: 10,
                 mx: "auto",
                 maxWidth: "1200px",
                 bgcolor: "background.paper",
               }}
             >
              <Box display="flex" alignItems="center" mb={3}>
                      <Typography variant="h4" fontWeight="bold" color="textPrimary">
                        Campaigns
                      </Typography>
                    </Box>
               <Typography variant="h5" component="h1" sx={{ mb: 3 }} color="textPrimary">
                 
               </Typography>
               <Divider sx={{ mb: 3 }} />
       
               <Box>

      <Grid container spacing={3}>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index} display="flex">
            <Card
              sx={{
                textAlign: "center",
                borderRadius: 3,
                boxShadow: 3,
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
                "&:hover": {
                  boxShadow: 6,
                  transform: "translateY(-5px)",
                },
                transition: "0.3s",
              }}
            >
              <Box>
                <CardHeader
                  avatar={
                    <Avatar
                      sx={{
                        bgcolor: "transparent",
                        width: 80,
                        height: 80,
                        margin: "0 auto",
                      }}
                    >
                      {card.icon}
                    </Avatar>
                  }
                />
                <CardContent>
                  <Typography variant="h6" gutterBottom color="textPrimary">
                    {card.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2, minHeight: 60 }}
                  >
                    {card.description}
                  </Typography>
                </CardContent>
              </Box>
              <Box pb={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => navigate(card.link)}
                >
                  Configure
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
      </Box>
    </Paper>
  );
}